import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BREAKPOINTS } from '../breakpoints';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  private readonly breakpoints = inject(BREAKPOINTS);

  private get commonConfig() {
    const isWeb = this.breakpoints.isWeb();
    return {
      horizontalPosition: isWeb ? ('end' as const) : ('center' as const),
      verticalPosition: isWeb ? ('top' as const) : ('bottom' as const),
    };
  }

  showErrorMessage(message: string, duration?: number) {
    const config: MatSnackBarConfig = {
      ...this.commonConfig,
      duration: duration ?? 5000,
      panelClass: 'error',
    };
    this.snackBar.open(message, undefined, config);
  }

  showSuccessMessage(message: string, duration?: number) {
    const config: MatSnackBarConfig = {
      ...this.commonConfig,
      duration: duration ?? 5000,
      panelClass: 'success',
    };
    this.snackBar.open(message, undefined, config);
  }

  showInfoMessage(message: string, duration?: number) {
    const config: MatSnackBarConfig = {
      ...this.commonConfig,
      duration: duration ?? 5000,
      panelClass: 'info',
    };
    this.snackBar.open(message, undefined, config);
  }
}
